var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-editor"},[_c('Editor',{attrs:{"id":_vm.editorId,"init":_vm.editorInit,"disabled":_vm.disabled},on:{"onClick":_vm.handleClick},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }